<template>
  <div class="dashboards-group-view-component">
    <div class="dashboard-navigation-bar">
      <router-link
        v-for="link in dashboardLinks"
        :key="link.resourceId"
        :to="createResourceLink(link)"
      >
        {{ link.name }}
      </router-link>
    </div>
    <dashboard-show />
    <catalog-index
      v-if="isCatalog"
      :show-header="false"
    />
  </div>
</template>

<script>
import DashboardShow from './show';
import CatalogIndex from '@/views/catalog/index';
import GlobalMixin from '@/mixins/global';
import DashboardMixin from '@/mixins/dashboard';

export default {
  components: {
    DashboardShow,
    CatalogIndex,
  },
  mixins: [GlobalMixin, DashboardMixin],
  props: { },
  computed: {
    navigationGroup() {
      const id = Number(this.$route.params.navigationGroupId);
      return this.$store.getters['navigationGroups/navigationGroups'][id];
    },
    dashboardLinks() {
      if (this.navigationGroup) {
        return this.navigationGroup?.navigationItems(this.$store)
          .filter(navItem => this.canAccessResource(navItem))
          .sort((a, b) => (a.order < b.order) ? -1 : 1)
          .map(navItem => {
            return {resourceId: navItem.resourceId, name: navItem.name, resourceType: navItem.resourceType, destination: navItem.destination};
          });
      }
    },
    catalogEnabled() {
      let user = this.$store.getters['user/get'];
      return user.catalogPricingEnabled;
    },
    isCatalog() {
      return this.$route.name === 'dashboardGroup#catalog';
    },
  },
  mounted() {
    if (this.dashboardLinks?.length === 0) {
      return this.$router.push({ name: 'mastery#home' });
    }
    this.$watch(
      () => this.dashboardLinks,
      (links) => {
        if (Array.isArray(links) && links.length === 0) {
          this.$router.push({ name: 'mastery#home' });
        }
      },
    );
    this.$watch('$route', (newRoute) => {
      const shouldUpdate = newRoute.name != 'dashboardGroup#catalog' && (!newRoute.params.dashboardId || !this.canAccessDashboard(newRoute.params.dashboardId));
      if (shouldUpdate && this.dashboardLinks?.length > 0) {
        const resource = this.dashboardLinks[0];
        const resourceLink = this.createResourceLink(resource);
        this.$router.replace(resourceLink);
      }
      if (newRoute.params.dashboardId) {
        this.$store.commit('dashboards/setLastVisitedId', [this.navigationGroup.id, Number(newRoute.params.dashboardId)]);
      }
    }, { immediate: true });
  },
  methods: {
    createResourceLink(resource) {
      let resourceLink = {};
      // catalog as a special case because there is no resource id,
      // each app has one and only one catalog
      if (resource.destination === 'catalog') {
        resourceLink = {
          name: 'dashboardGroup#catalog',
          params: {
            navigationGroupId: this.navigationGroup.id,
          },
          query: this.currentQuery,
        };
      } else if (resource.resourceType === 'AppDashboard') {
        resourceLink = {
          name: 'dashboard#group',
          params: {
            navigationGroupId: this.navigationGroup.id,
            dashboardId: resource.resourceId,
          },
          query: this.currentQuery,
        };
      }
      return resourceLink;
    },
  },
};
</script>

<style lang="scss" scoped>
  .dashboards-group-view-component {
    padding: 0 !important;

    .dashboard-navigation-bar {
      display: flex;
      padding: 0 2rem;
      border-bottom: 1px solid $elements-base;

      a {
        padding: 1rem 5px;
        margin: 0 1rem;
        font-size: 1rem;
        text-decoration: none;
        color: #767676;

        &.router-link-active {
          font-weight: bold;
          color: #000000;
          border-bottom: 2px solid #000000;
        }
      }
    }

    .dashboard-container {
      padding: 2rem;
    }

    @include breakpoint(small) {
      .dashboard-navigation-bar {
        padding-left: 0;
      }
    }
  }
</style>
